var _path, _rect, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIndustry(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 13.6006V16.6006",
    stroke: "#626262",
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 13.6006,
    width: 8,
    height: 3,
    rx: 0.5,
    stroke: "#626262",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9.60059L12.0003 9.58208C11.9938 9.75854 12.0808 9.92537 12.2293 10.021C12.3778 10.1166 12.5657 10.1268 12.7236 10.0478L12.5 9.60059ZM13.9211 8.89002L14.1447 9.33723L13.9211 8.89002ZM12.9997 9.61909L13.3083 1.28684L12.3089 1.24983L12.0003 9.58208L12.9997 9.61909ZM13.6948 1.28595L13.9735 7.97477L14.9726 7.93314L14.6939 1.24432L13.6948 1.28595ZM13.6975 8.4428L12.2764 9.15337L12.7236 10.0478L14.1447 9.33723L13.6975 8.4428ZM13.9735 7.97477C13.9817 8.17151 13.8737 8.35474 13.6975 8.4428L14.1447 9.33723C14.6731 9.07305 14.9972 8.52336 14.9726 7.93314L13.9735 7.97477ZM13.5015 1.10059C13.6052 1.10059 13.6905 1.18235 13.6948 1.28595L14.6939 1.24432C14.6673 0.605093 14.1413 0.100586 13.5015 0.100586V1.10059ZM13.3083 1.28684C13.3121 1.18288 13.3975 1.10059 13.5015 1.10059V0.100586C12.8596 0.100586 12.3327 0.608354 12.3089 1.24983L13.3083 1.28684Z",
    fill: "#626262"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11.1668V15.6006C1 16.1529 1.44772 16.6006 2 16.6006H15C15.5523 16.6006 16 16.1529 16 15.6006V9.36678C16 8.58948 15.152 8.10937 14.4855 8.50928L12.2862 9.82884C11.7202 10.1685 11 9.76073 11 9.10059C11 8.44044 10.2798 8.03269 9.71376 8.37233L7.28624 9.82884C6.72017 10.1685 6 9.76073 6 9.10059C6 8.44044 5.27983 8.03269 4.71376 8.37233L1.4855 10.3093C1.1843 10.49 1 10.8155 1 11.1668Z",
    stroke: "#626262",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndustry);
export default __webpack_public_path__ + "static/media/industry.924605f88e4877411dcc02d4ebecc9ee.svg";
export { ForwardRef as ReactComponent };